import { useState } from 'react';
import { Badge } from '@/components/ui/Badge';
import { SegmentedControl } from '@/components/ui/SegmentedControl';
import IpPharmacyTab from '../ipCounter/IpPharmacyTab';
import IpWorklist from './IpWorklist';
import { useWorklist } from './hooks';

type View = 'worklist' | 'counter';

/**
 * Pharmacy → 🏨 IP Pharmacy: the ward-request worklist (multi-store Phase 4)
 * and the existing attender counter, side by side. Opens on the worklist so a
 * waiting ward request is the first thing the IP pharmacist sees.
 */
export default function IpPharmacyScreen() {
  const [view, setView] = useState<View>('worklist');
  const waiting = useWorklist().data?.requests.length ?? 0;
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap items-center gap-2">
        <SegmentedControl
          options={[{ value: 'worklist' as const, label: 'Ward requests' }, { value: 'counter' as const, label: 'Counter' }]}
          value={view} onChange={setView} className="w-[280px]"
        />
        {waiting > 0 && view !== 'worklist' && <Badge variant="warn">{waiting} waiting</Badge>}
      </div>
      {view === 'worklist' ? <IpWorklist /> : <IpPharmacyTab />}
    </div>
  );
}
